var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-container"},[_c('div',{staticClass:"box-nested-container"},[_c('div',{staticClass:"box",class:_vm.right?'right':'left'},[_c('div'),_c('div'),_c('div')])])])
}
var staticRenderFns = []

export { render, staticRenderFns }